/*
 * No&Low delivery estimate for the product page.
 * Works in Europe/London time whatever the visitor's clock says.
 * Dispatch day: today if before the cut-off on a working day, otherwise the next working day.
 * Next day (DPD) = dispatch + 1 working day. Standard (Royal Mail 48) = dispatch + 2 working days.
 * Working days: Monday to Friday, excluding the bank holidays set in Theme settings.
 */
(function () {
  if (customElements.get('nl-delivery-estimate')) return;

  var DAY = 86400000;

  // Calendar dates are held as UTC midnight so adding days never trips over clock changes
  function londonNow() {
    var now = window.__nlNow ? new Date(window.__nlNow) : new Date();
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(now).forEach(function (p) { parts[p.type] = p.value; });
    return {
      date: Date.UTC(+parts.year, +parts.month - 1, +parts.day),
      minutes: +parts.hour * 60 + +parts.minute
    };
  }

  function iso(d) {
    return new Date(d).toISOString().slice(0, 10);
  }

  function formatDay(d) {
    return new Date(d).toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
  }

  class NlDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.holidays = (this.dataset.holidays || '').split(/[\s,]+/).filter(Boolean);
      this.cutoff = (parseInt(this.dataset.cutoffHour, 10) || 16) * 60;
      // The progress bar is full at this time (or earlier) and empties at the cut-off
      this.windowStart = (parseInt(this.dataset.windowStartHour, 10) || 8) * 60;
      this.render();
      this.timer = setInterval(this.render.bind(this), 30000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    isWorkingDay(d) {
      var weekday = new Date(d).getUTCDay();
      return weekday >= 1 && weekday <= 5 && this.holidays.indexOf(iso(d)) === -1;
    }

    addWorkingDays(d, count) {
      var day = d;
      var added = 0;
      while (added < count) {
        day += DAY;
        if (this.isWorkingDay(day)) added++;
      }
      return day;
    }

    render() {
      var now = londonNow();
      var dispatchToday = this.isWorkingDay(now.date) && now.minutes < this.cutoff;
      var dispatch = dispatchToday ? now.date : this.addWorkingDays(now.date, 1);

      var left = this.cutoff - now.minutes;
      var countdown = this.querySelector('[data-countdown]');
      if (countdown) {
        if (dispatchToday) {
          var hours = Math.floor(left / 60);
          var mins = left % 60;
          var time = document.createElement('strong');
          time.textContent = (hours > 0 ? hours + 'h ' : '') + mins + 'm';
          countdown.replaceChildren('Order within ', time, ' for dispatch today');
        } else {
          countdown.textContent = 'Order now for dispatch on ' + formatDay(dispatch);
        }
      }

      // Progress through the dispatch day: fills left to right from the window start to the cut-off,
      // shown only while same-day dispatch is still possible
      var bar = this.querySelector('[data-bar]');
      if (bar) {
        if (dispatchToday) {
          var windowLength = Math.max(this.cutoff - this.windowStart, 1);
          var share = Math.min(Math.max((now.minutes - this.windowStart) / windowLength, 0), 1);
          bar.style.setProperty('--nl-delivery-fill', (share * 100).toFixed(1) + '%');
          bar.classList.toggle('nl-delivery__bar--last-hour', left <= 60);
          bar.hidden = false;
        } else {
          bar.hidden = true;
        }
      }

      var nextDay = this.querySelector('[data-next-day]');
      if (nextDay) nextDay.textContent = formatDay(this.addWorkingDays(dispatch, 1));

      var standard = this.querySelector('[data-standard]');
      if (standard) standard.textContent = formatDay(this.addWorkingDays(dispatch, 2));

      this.setAttribute('data-ready', '');
    }
  }

  customElements.define('nl-delivery-estimate', NlDeliveryEstimate);
})();
